/* eslint-disable import/prefer-default-export */
/*
 * @File Name:
 * @Author: mhyu
 * @Date: 2022-02-09 13:53:02
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-02-09 15:38:22
 * @Description:
 * @FilePath: \src\global\index.js
 */
import axios from './axios';

export { axios };
